import React from 'react';

const InputImage = ({label, url, fileName, name, onChange, required}) => {
  return (
    <div className="InputImage wrap-adminInput">
      <label className="input-label" htmlFor={name}>{label}</label>

      <div className="wrap-file">
        <label className = {`input-el cursor ${url ? `active` : ""}`} htmlFor={name}>{fileName}</label>
        {url ? <img src={url} alt="profile"/> : ""}
      </div>

      <input type="file" onChange={onChange} name = {name} id = {name} required = {required}/>
    </div>
  );
}

export default InputImage;